import React from 'react';

const BlogSection = () => {
	return (
		<section className='blog'>
			<h2>Blog</h2>
			<button className='secondaryLarge'>Zobacz więcej</button>
		</section>
	);
};

export default BlogSection;
